import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { Button, Input } from 'reactstrap';

import * as Constants from './Constants.js';

var Fasta = require('biojs-io-fasta');

var findRightDiff = function(s1, s2) {
  var i = s1.length + 1;
  while (i--) {
    if (s2.indexOf(s1[i]) >= 0)
      s2.splice(s2.indexOf(s1[i]), 1);
  }
  return s2;
}

class InputData extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      pastedData : "",
      uploadFilename : "",
      uploadFile : null,
      inputSequences : null,
      inputIntervals : null,
      inputFormat : null,
      alphabetValid : null,
      uploadMessage : "",
      uploadIsError : false
    };
    this.fileUpload = React.createRef();
  }
  
  UNSAFE_componentWillMount() {
    this.props.updateDesign(this.state);
  }
  
  handleUploadFile = (event) => {
    /* https://www.html5rocks.com/en/tutorials/file/dndfiles/ */
    let self = this; 
    if (window.File && window.FileReader && window.FileList && window.Blob) {
      var uploadFilename = event.target.files[0].name;
      var uploadFile = this.fileUpload.files[0];
      var uploadFileSize = uploadFile.size;
      if (uploadFileSize > Constants.epilogosMemeUploadFileMaxSize) {
        self.setState({ uploadFilename: uploadFilename, uploadMessage : 'Please upload a file smaller than 1 MB in size', uploadIsError: true });
      }
      else {
        var reader = new FileReader();
        reader.onload = (function(theFile) {
          return function(e) {
            var data = e.target.result;
            self.handleData(data);
            self.setState({ pastedData : "" });
          };
        })(uploadFile);
        reader.readAsText(uploadFile, 'UTF-8');
      }
    } else {
      self.setState({ uploadMessage : 'Javascript File APIs are not fully supported in this browser', uploadIsError: true });
    }
    document.activeElement.blur();
  }
  
  handlePasteTextareaChange = (event) => {
    this.setState({
      pastedData: event.target.value
    }, function() {
      var data = this.state.pastedData;
      this.handleData(data, this);
    });
  }
  
  handleData = (data) => {
    let inputFormatToMutateTo = null;
    let self = this;
    // FASTA
    if (data.startsWith(">")) {
      var addFasta = true;
      var alphabetValid = true;
      let msg = "FASTA data uploaded!";
      let err = false;
      var seqObjs = Fasta.parse(data);
      // validate sequences
      Object.keys(seqObjs).forEach(function(key) {
        if (addFasta) {
          var seqObj = seqObjs[key];
          // test length threshold
          if (seqObj.seq.length < Constants.epilogosMemeFASTASequenceMinimumLength) {
            addFasta = false;
            msg = `Input sequence less than minimum length (${Constants.epilogosMemeFASTASequenceMinimumLength}) at line ${key} (${seqObj.name})`;
            err = true;
          }
          // test alphabet
          else {
            var observedSeqCharacterSet = new Set(seqObj.seq.split(''));
            var expectedSeqCharacters = Constants.epilogosMemeAlphabets[self.props.currentGenome][self.props.currentStateModel];
            var charsInObservedSequenceNotInExpectedSequence = findRightDiff(expectedSeqCharacters, Array.from(observedSeqCharacterSet));
            if (charsInObservedSequenceNotInExpectedSequence.length > 0) {
              addFasta = false;
              alphabetValid = false;
              msg = `One or more input sequences contain residues that are not in the alphabet of selected state model`;
              err = true;
            }
          }
        }
      });
      var seqObjsToAdd = (addFasta) ? seqObjs : null;
      inputFormatToMutateTo = (addFasta) ? "FASTA" : null;
      self.setState({
        inputIntervals : null,
        inputSequences : seqObjsToAdd,
        inputFormat : inputFormatToMutateTo,
        alphabetValid : alphabetValid,
        uploadMessage: msg,
        uploadIsError: err
      }, () => {
        self.props.updateDesign(self.state);
      })
    }
    // BED
    else {
      var addBed = true;
      let msg = 'BED data uploaded!';
      let err = false;
      data = data.replace(/[\r]+/gm, '').trim();
      var bedLines = data.split('\n');
      var firstBedLine = bedLines[0];
      if (firstBedLine.split('\t').length < 3) {
        msg = `First line failed to have necessary columns [${firstBedLine}]`;
        err = true;
        //throw new Error(err);
        addBed = false;
      }
      if (addBed) {
        for (var lineIdx in bedLines) {
          var bedLineElements = bedLines[lineIdx].split('\t');
          if (bedLineElements.length === 3) {
            bedLineElements.push(".", ".", "+");
          }
          else if (bedLineElements.length === 4) { 
            bedLineElements.push(".", "+");
          }
          else if (bedLineElements.length === 5) { 
            bedLineElements.push("+");
          }
          else if ((bedLineElements.length >= 6) && (bedLineElements[5] !== '+') && (bedLineElements[5] !== '-')) {
            console.log("line failed", bedLines[lineIdx]);
            console.log("column 6 failure on: [" + JSON.stringify(bedLines[lineIdx]) + "]");
            addBed = false;
            msg = 'Sixth-column of BED6+ input should contain strand information (+/-). See element [' + JSON.stringify(bedLines[lineIdx]) + ']';
            err = true;
            break;
          }
          bedLines[lineIdx] = bedLineElements.join('\t');
        }
      }
      var intervalsToAdd = (addBed) ? bedLines : null;
      inputFormatToMutateTo = (addBed) ? "BED" : null;
      self.setState({
        inputIntervals : intervalsToAdd,
        inputSequences : null,
        inputFormat : inputFormatToMutateTo,
        alphabetValid : null,
        uploadMessage: msg,
        uploadIsError: err
      }, () => {
        self.props.updateDesign(self.state);
      })
    }
  }
  
  exampleDataTransform = (d) => {
    return d;
  }
  
  render() {
    let headerNotice = 
      <p className='panel-label-notice'>
        Please either <strong>paste</strong> tab-delimited, 3- or more-column BED-formatted intervals of interest, or a FASTA file containing sequences (with an alphabet matching the selected state model), or <strong>upload</strong> BED3+ or FASTA (with the same format constraints).
      </p>
    
    return (
      <div>
        {headerNotice}
        <div className="panel-subsection panel-subsection-paste">
          {/*<label htmlFor="input-paste" className="panel-label input-paste-label">Paste</label>*/}
          <FormGroup className="input-paste-form" controlId="formControlsTextarea">
            <Input type="textarea" className="input-paste-textarea" placeholder="" value={this.state.pastedData} onChange={this.handlePasteTextareaChange} />
            <div>
              <Button className="btn-epilogos" color="primary" size="sm" onClick={(e)=>{ 
                let data = Constants.exampleData.BED;
                this.handleData(data);
                this.setState({ 
                  pastedData: data 
                });
                this.props.updateDesignForExampleBED();
                document.activeElement.blur(); 
              }}>
                Paste example BED
              </Button>
            </div>
          </FormGroup>
        </div>
        <div className="panel-subsection-last">
          {/*<label htmlFor="query-upload-filename" className="panel-label query-label-upload">Upload</label>*/}
          <form ref="uploadForm" id="upload-form" className="uploader btn-epilogos-upload-wrap" encType="multipart/form-data" >
            <label htmlFor="fileUploadInput" className="btn-epilogos btn-epilogos-upload">Upload</label>
            <input ref={(ref) => this.fileUpload = ref} id="fileUploadInput" type="file" name="file" className="query-upload-file" onChange={this.handleUploadFile} />
          </form>
        </div>
        <p className={'panel-label-notice '+(this.state.uploadIsError?'panel-label-error':'panel-label-success')}>{this.state.uploadMessage}</p>
      </div>
    )
  }
}

export default InputData;